
import VueFilters from "@/vue-filters";
import { Component, Prop, Vue } from "vue-property-decorator";
import { BvTableFieldArray } from "bootstrap-vue";
import { IContainer } from "@/entities";
import { LocaleMessage } from "vue-i18n";
import IconEdit from "@/components/common/icon/IconEdit.vue";
import IconTrash from "@/components/common/icon/IconTrash.vue";
import { PropType } from "vue";

@Component({
  name: "declared-container-details",
  components: { IconTrash, IconEdit },
  mixins: [VueFilters],
})
export default class DeclaredContainerDetails extends Vue {
  @Prop({ required: false, default: () => [], type: Array as PropType<IContainer[]> })
  containers!: IContainer[];
  @Prop({ required: false, default: false, type: Boolean }) edit!: boolean;

  get fields(): BvTableFieldArray {
    return [
      {
        key: "actions-left",
        label: "",
        sortable: false,
        thClass: "table-header table-header-active pl-4",
        tdClass: "table-cell-first align-middle position-relative",
      },
      {
        key: "type",
        label: this.$t("column.type") as string,
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-middle align-middle",
        formatter: (_value: number, _key: string, item: IContainer): LocaleMessage | string => {
          return item.sc ? this.$t("label.seal") : this.$t("label.bag");
        },
      },
      {
        key: "co",
        label: this.$t("column.code") as string,
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-middle align-middle",
        formatter: (_value: number, _key: string, item: IContainer): string => {
          return item.sc || item.bc || "";
        },
      },
      {
        key: "actions-right",
        label: "",
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-last align-middle",
      },
    ];
  }

  onClickEdit(value: IContainer): void {
    this.$emit("edit", value);
  }

  onClickDelete(value: IContainer): void {
    this.containers.splice(this.containers.indexOf(value), 1);
  }
}
